import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { LinkedService } from './linkedservice';
import { format } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: ModelConstants.fabricAirflowLinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.AirflowEntity),
        format(shellStringResources.ModelName_LinkedServicesTemplate, shellStringResources.AirflowEntity)
    ]
})
export class FabricAirflowLinkedService extends LinkedService { }